import { render, staticRenderFns } from "./CompanyTabOrders.vue?vue&type=template&id=511498da&scoped=true&"
import script from "./CompanyTabOrders.vue?vue&type=script&lang=ts&"
export * from "./CompanyTabOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511498da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
